export const ALWAYS_CAPITALIZE_WORDS = ['AI', 'LLC'];